module.exports = __webpack_public_path__ + "images/landing/light/video-maker.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/light/video-maker.png
// module id = SXt6
// module chunks = 51